import React, { FC } from 'react'
import Paper from '@mui/material/Paper'
import Container from '@mui/material/Container'

const Example: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container 
      maxWidth="lg" 
      sx={{ 
        padding: theme => theme.spacing(4)
      }}
    >
      <Paper 
        sx={{ 
          padding: theme => theme.spacing(4)
        }}
      >
        <div>
          Hello
        </div>
      </Paper>
    </Container>
  )
}

export default Example